import { DetailedHTMLProps, HTMLAttributes } from "react";

const Row: React.FC<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ className, children, ...props }) => {
  return (
    <div className={`row ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Row;
